import { render, staticRenderFns } from "./PanelFundraiserThanks.vue?vue&type=template&id=5bfee439&scoped=true&"
import script from "./PanelFundraiserThanks.vue?vue&type=script&lang=js&"
export * from "./PanelFundraiserThanks.vue?vue&type=script&lang=js&"
import style0 from "./PanelFundraiserThanks.vue?vue&type=style&index=0&id=5bfee439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfee439",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VImg,VSelect,VTextField})
